/**
 * Creates a new object composed of picked object properties.
 * @param obj The source object.
 * @param keys The property paths to pick.
 */
export function pick<T, K extends keyof T>(obj: T, ...keys: K[]): Pick<T, K> {
  const ret = {} as Pick<T, K>;
  keys.forEach((key) => {
    ret[key] = obj[key];
  });
  return ret;
}
